import discountedPrice, { grantsFreeMagnets } from '../../utils/offerPricing';

// What the elementary "Download all my photos" (Buy All Digital) card says about
// price and offer (issue #5218 item 6, absorbing #5217). ONE pure function so the
// tile in the gallery and the older favourites screen read identically, and so
// the copy is derived from the LIVE offer -- never baked into the banner art.
//
//   % tier live (ELEM20, days 0-14)  ribbon "20% OFF", was/now via discountedPrice()
//   magnet tier live (days 15-45)    ribbon "+2 FREE MAGNETS", real price only
//   no offer                         real price only, no ribbon
//
// discountedPrice() is the single client discount computation; this never
// re-derives a percentage.
export const FREE_MAGNETS_RIBBON = '+2 FREE MAGNETS';

export default function buyAllCardModel({ option, offer }) {
  const price = Number(option?.price);
  const hasPrice = !Number.isNaN(price) && price > 0;
  const discounted = hasPrice ? discountedPrice(price, offer) : null;

  let ribbon = null;
  if (grantsFreeMagnets(offer)) ribbon = FREE_MAGNETS_RIBBON;
  else if (discounted != null) ribbon = `${Number(offer.value)}% OFF`;

  const listPrice = hasPrice ? price : null;
  return {
    price: listPrice,
    wasPrice: discounted != null ? price : null,
    nowPrice: discounted != null ? discounted : listPrice,
    ribbon,
    freeMagnets: grantsFreeMagnets(offer),
  };
}
